import { createServerOnlyFn } from "@tanstack/react-start";

import {
  setBadRequestResponseStatus as setBadRequestResponseStatusServer,
  setGoneResponseStatus as setGoneResponseStatusServer,
} from "./response-status.server";

export const setBadRequestResponseStatus = createServerOnlyFn(() => {
  setBadRequestResponseStatusServer();
});

export const setGoneResponseStatus = createServerOnlyFn(() => {
  setGoneResponseStatusServer();
});
